import { utils } from '@kurtosys/ksys-app-template';
const ksysCollapsingMarginFixClassName = 'ksys-collapsing-margin-fix';
export function splitApp(element: HTMLElement, remainingPageHeight: number, pageHeight: number) {
	injectStyles();
	const size = utils.layout.getHtmlElementSize(element);
	const table = getElementMetaFromSelector(element, 'table');
	const thead = getElementMetaFromSelector(table.element, 'thead');
	const tbody = getElementMetaFromSelector(table.element, 'tbody');
	const rows = getElementsMetaFromSelector(tbody.element, 'tr');
	const disclaimers = getElementMetaFromSelector(element, '[data-selector="base-table-disclaimersWrapper"]');
	const cardHeader = getElementMetaFromSelector(element, 'header[data-selector="base-card-header"]');
	const height = size.height;
	const calculatedHeight = (cardHeader.size.height || 0) + (table.size.height || 0) + (disclaimers.size.height || 0);
	const margin = (height || 0) - calculatedHeight;

	const instances: any[] = [];
	let instance: { height: number, heights: number[], start: number, limit: number, hasCardHeader: boolean, hasDisclaimers: boolean } = {
		heights: [(cardHeader.size.height || 0), margin, (thead.size.height || 0)],
		height: (cardHeader.size.height || 0) + margin + (thead.size.height || 0),
		start: 0,
		limit: 0,
		hasCardHeader: true,
		hasDisclaimers: false,
	};

	let maxHeight = remainingPageHeight > 0 ? remainingPageHeight : pageHeight;
	// If no rows are present then we are just going to go to a new page
	if (instance.height > maxHeight) {
		maxHeight = pageHeight;
	}
	rows.forEach((row, rowIndex) => {
		const rowHeight = (row.size.height || 0);
		// We are on the first row and the card header, margin and thead is too big to allow a row in,
		// so we bump it to a full page to not have an empty header displaying
		if (rowIndex === 0 && maxHeight !== pageHeight && (rowHeight + instance.height) > maxHeight) {
			maxHeight = pageHeight;
		}
		if (rowHeight + instance.height <= maxHeight) {
			instance.heights.push(rowHeight);
			instance.height += rowHeight;
			instance.limit++;
		}
		else {
			instances.push(instance);
			// If there was a remainingPageHeight we now move onto a new page
			maxHeight = pageHeight;
			instance = {
				heights: [margin, (thead.size.height || 0), rowHeight],
				height: margin + (thead.size.height || 0) + rowHeight,
				start: rowIndex,
				limit: 1,
				hasCardHeader: false,
				hasDisclaimers: false,
			};
		}
	});
	if (instance && instance.limit > 0) {
		if (instance.height + (disclaimers.size.height || 0) <= maxHeight) {
			instance.heights.push((disclaimers.size.height || 0));
			instance.height += (disclaimers.size.height || 0);
			instance.hasDisclaimers = true;
		}
		else {
			instances.push(instance);
			instance = {
				heights: [margin, (disclaimers.size.height || 0)],
				height: margin + (disclaimers.size.height || 0),
				hasDisclaimers: true,
				hasCardHeader: false,
				limit: -1,
				start: -1,
			};
		}
		instances.push(instance);
	}
	return instances;
}

function getElementMetaFromSelector(parent: HTMLElement | null, selector: string) {
	const element = parent && parent.querySelector(selector);
	return getElementMeta(element);
}

function getElementsMetaFromSelector(parent: HTMLElement | null, selector: string) {
	const elements = parent && parent.querySelectorAll(selector);
	return Array.from(elements || []).map(getElementMeta);
}

function getElementMeta(element: Element | HTMLElement | null) {
	if (element) {
		const htmlElement = element as HTMLElement;
		if (!htmlElement.classList.contains(ksysCollapsingMarginFixClassName)) {
			htmlElement.classList.add(ksysCollapsingMarginFixClassName);
		}
	}
	return {
		element: element as HTMLElement,
		size: (element && utils.layout.getHtmlElementSize(element as HTMLElement)) || {},
	};
}

function injectStyles() {
	const id = 'app-split-styles';
	const existing = document.querySelector(`#${ id }`);
	if (!existing) {
		const style = document.createElement('style');
		style.type = 'text/css';
		style.id = id;
		style.appendChild(
			document.createTextNode(`
				.${ ksysCollapsingMarginFixClassName } {
					overflow: auto;
				}
			`),
		);
		const body = document.querySelector('body');
		if (body) {
			body.appendChild(style);
		}
	}
}